export const TYPES = Object.seal(
  Object.freeze({
    CREATE_USER_ERROR: "createUserError",
    CREATE_SUBSCRIPTION_PURCHASE_ERROR: "createSubscriptionPurchaseError",
    CREATE_SIMPLE_PURCHASE_ERROR: "createSimplePurchaseError",
  }),
);
